import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';

// 🟢 [修复] 引用路径修改为指向 common 文件夹
import UserAvatar from '../common/UserAvatar';
import EditProfileModal from '../common/EditProfileModal';
// 🟢 [图标升级·方案A] 扁平渐变图标
import GradientIcon from '../common/GradientIcon';

const Navbar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isProfileOpen, setProfileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  let navItems = [];
  // 🟢 [修复] 原来 else 是兜底分支，未登录 (user === null) 时也会拿到整套学生导航，
  // 而那些链接全在 PrivateRoute 后面，点了只会被弹回 /login。
  if (!user) navItems = [];
  else if (user?.role === 'admin') navItems = [{ path: '/admin', icon: 'settings', label: 'Admin' }];
  else if (user?.role === 'teacher') navItems = [{ path: '/teacher', icon: 'teacher', label: 'Teacher' }];
  else navItems = [
      { path: '/dashboard', icon: 'dashboard', label: 'Dashboard' },
      { path: '/courses', icon: 'courses', label: 'Courses' },
      { path: '/games', icon: 'games', label: 'Games' },
      { path: '/progress', icon: 'progress', label: 'Progress' },
      { path: '/shop', icon: 'shop', label: 'Shop' }
    ];

  return (
    <>
      <motion.nav initial={{ y: -100 }} animate={{ y: 0 }} className="bg-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between items-center h-16">
            <Link to={user ? '/dashboard' : '/'} className="flex items-center space-x-2">
              <motion.div whileHover={{ scale: 1.1 }} className="flex items-center gap-2 text-2xl font-bold bg-gradient-to-r from-sky-500 to-blue-500 bg-clip-text text-transparent font-kid">
                <img src="/images/logo.png" alt="Logo" className="w-8 h-8 object-contain drop-shadow-sm" />
                VOCAB RUN
              </motion.div>
            </Link>

            <div className="hidden md:flex items-center space-x-1">
              {navItems.map((item) => (
                <Link key={item.path} to={item.path} className={`flex items-center px-4 py-2 rounded-lg transition-all duration-200 ${location.pathname === item.path ? 'bg-sky-50 text-sky-500 font-bold' : 'text-gray-600 hover:bg-gray-100'}`}>
                  <GradientIcon name={item.icon} size={20} className="mr-2" />{item.label}
                </Link>
              ))}
            </div>

            <div className="flex items-center space-x-4">
              {user ? (
                <div className="flex items-center space-x-4">
                  {user.points !== undefined && (
                    <div className="hidden sm:flex items-center text-sky-500 font-bold bg-sky-50 px-3 py-1 rounded-full text-sm">
                      <GradientIcon name="coins" size={16} className="mr-1" />{user.points}
                    </div>
                  )}
                  {/* 用户信息区：点击打开编辑弹窗 */}
                  <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => setProfileOpen(true)} className="flex items-center gap-2 cursor-pointer p-1 rounded-lg hover:bg-gray-100 transition-colors" title="Edit Profile">
                    <UserAvatar avatarId={user.avatarId} customAvatarUrl={user.customAvatarUrl} inventory={user.inventory} size="sm" className="border-2 border-white shadow-sm" />
                    <span className="font-bold text-gray-800 text-sm hidden sm:block">{user.name}</span>
                  </motion.div>
                  <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={handleLogout} className="bg-red-500 hover:bg-red-600 text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-md transition-colors">Logout</motion.button>
                </div>
              ) : (
                <div className="flex items-center space-x-2">
                   <Link to="/login" className="text-gray-600 hover:text-gray-800 font-bold px-4">Login</Link>
                   <Link to="/register" className="bg-sky-500 hover:bg-sky-600 text-white px-4 py-2 rounded-full font-bold shadow-md">Register</Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </motion.nav>
      {/* 🟢 [P1] 移动端底部 Tab 栏：K12 平板/手机用户的标准导航方式
          仅在多入口角色（学生）下显示；桌面端(md 及以上)隐藏 */}
      {navItems.length > 1 && (
        <>
          <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.08)] pb-[env(safe-area-inset-bottom)]">
            <div className="flex justify-around items-stretch">
              {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex flex-1 flex-col items-center justify-center py-2 text-[11px] font-bold transition-colors ${isActive ? 'text-sky-500' : 'text-gray-400'}`}
                  >
                    <GradientIcon name={item.icon} size={24} className={`mb-0.5 transition-transform ${isActive ? 'scale-110' : ''}`} />
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </nav>
        </>
      )}

      {/* 弹窗挂载 */}
      <EditProfileModal isOpen={isProfileOpen} onClose={() => setProfileOpen(false)} />
    </>
  );
};

export default Navbar;